<template>
<v-card v-resize="onResize" class="ma-2 pa-2" height = "100%"> 
  <v-card-text>
    <p class="text-center title pb-0 mb-0 font-weight-regular">Temp (F) and Energy Usage (kWh)</p>
  </v-card-text>
  <div id='pieGraph' style='height:600px;'></div>
</v-card>
</template>
<script>
import shine from '@/components/plugins/echarts-theme-shine';

export default{
  data: () => ({
    PVgen_MW: null,
    cchw_MW: null,
    hvac_MW: null,
    plug_MW: null,
    lighting_MW: null,
    special_MW: null,
    dwh_MW: null,
    color: null,
    cchw_mult: null,

    supply_MW: null,
    demand_MW: null,

    pieGraph: null,
  }),
  methods: {
    showGraph: _.debounce(async function() {

      if (this.runState === "running") {
        this.pieGraph.showLoading()
        
      } else if (this.runState === "finished"){
        this.retrieveData()
        this.pieGraph.hideLoading()
        this.refreshGraph()
      }
    }),
    onResize() {  // calls echarts .resize function when viewing window changes
      if(this.pieGraph) _.debounce(this.pieGraph.resize, 100)()
    },
    refreshGraph() {
      if (this.cchw_MW > 0) {
        this.color = ['#f4b786', '#8eadca', '#8eadca', '#8eadca', '#8eadca', '#8eadca', '#8eadca' ]
        this.cchw_mult = 1
      } else {
        this.cchw_mult = -1
        this.color = ['#f4b786', '#f4b786', '#8eadca', '#8eadca', '#8eadca', '#8eadca', '#8eadca' ]
      }
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        colorBy: 'series',
        /*legend: {
            data: ["PVgen", "CCHW", "HVAC","Plug",
                    "Lighting", 'Special', "DWH"]
        },*/
        toolbox: {
            feature: {
                saveAsImage: {}
            }
        }, 
        series: [
        {
          name: 'Access From',
          type: 'pie',
          color: ['#e98332','#6e9ec9'],
          selectedMode: 'single',
          radius: [0, '31%'],
          label: {
            position: 'inner',
            fontSize: 13,
            fontWeight: 'bold',
            align: 'left',
          },
          labelLine: {
            show: false
          },
          data: [
            { value: this.supply_MW, name: 'Supply'},
            { value: this.demand_MW, name: 'Demand' },
          ],
          itemStyle: {
            borderWidth: 1,
            borderColor: '#ffffff'
          }
        },
        {
          name: 'Access From',
          type: 'pie',
          color: this.color,
          radius: ['32%', '60%'],
          labelLine: {
            length: 30
          },
          label: {
            formatter: '  {b|{b}：}{c} MW {per|{d}%}  ',
            backgroundColor: '#F6F8FC',
            borderColor: '#8C8D8E',
            borderWidth: 1,
            borderRadius: 4,
            rich: {
              a: {
                color: '#6E7079',
                lineHeight: 22,
                align: 'center'
              },
              hr: {
                borderColor: '#8C8D8E',
                width: '100%',
                borderWidth: 1,
                height: 0
              },
              b: {
                color: '#4C5058',
                fontSize: 14,
                fontWeight: 'bold',
                lineHeight: 33
              },
              per: {
                color: '#fff',
                backgroundColor: '#4C5058',
                padding: [3, 4],
                borderRadius: 4
              }
            }
          },
          data: [
            { value: this.PVgen_MW, name: 'PVgen', groupID: 'supply' },
            { value: this.cchw_MW*this.cchw_mult, name: 'CCHW', groupID: 'demand' },
            { value: this.hvac_MW, name: 'HVAC', groupID: 'demand' },
            { value: this.plug_MW, name: 'Plug', groupID: 'demand' },
            { value: this.lighting_MW, name: 'Lighting', groupID: 'demand' },
            { value: this.special_MW, name: 'Special', groupID: 'demand' },
            { value: this.dwh_MW, name: 'DWH', groupID: 'demand' },
          ],
          itemStyle: {
            borderWidth: 1,
            borderColor: '#ffffff'
          }
        }
        ]
      };
      this.pieGraph.setOption(option)
    },
    retrieveData(){
      this.PVgen_MW = Math.round(this.$store.state.DTW_data.PVgen.reduce((a, b) => { return a + b;}))/1000
      this.cchw_MW =  Math.round(this.$store.state.DTW_data.cchw_kW.reduce((a, b) => { return a + b;}))/1000
      this.hvac_MW =  Math.round(this.$store.state.DTW_data.real_HVAC.reduce((a, b) => { return a + b;}))/1000
      this.plug_MW = Math.round(this.$store.state.DTW_data.plug_kW.reduce((a, b) => { return a + b;}))/1000
      this.lighting_MW =  Math.round(this.$store.state.DTW_data.lighting_kW.reduce((a, b) => { return a + b;}))/1000
      this.special_MW = Math.round(this.$store.state.DTW_data.special_kW.reduce((a, b) => { return a + b;}))/1000
      this.dwh_MW = Math.round(this.$store.state.DTW_data.dwh_kW.reduce((a, b) => { return a + b;}))/1000

      this.supply_MW = this.PVgen_MW
      this.demand_MW = this.hvac_MW + this.plug_MW + this.lighting_MW + this.special_MW + this.dwh_MW
      if (this.cchw_MW > 0) {
        this.demand_MW = this.demand_MW + this.cchw_MW
      } else {
        this.supply_MW = this.supply_MW - this.cchw_MW
      }
    }
  },
  watch: {
    '$store.state.DTW.run': function() {
      this.showGraph()
    },
  },
  computed: {
    runState(){
      return this.$store.state.DTW.run
    },
  },
  async mounted() {
    echarts.registerTheme('shine', shine)
    this.pieGraph = echarts.init(document.querySelector('#pieGraph'))
    await this.showGraph()
    
  }
}
</script>
